
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';



import { AuthHttp } from '../../admin/services/token.service';
import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class CreditApprovalService {

    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    approveInitiatedLoanBookingRequest(formObj,loanBookingRequestId) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`loan/loan-request/approval/${loanBookingRequestId}`, bodyObj).pipe(
          map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    
    // approveLineMaintenance(formObj,loanBookingRequestId) {
    //     let bodyObj = JSON.stringify(formObj);
    //     return this.http.post(`loan/line-maintenance/approval/${loanBookingRequestId}`, bodyObj)
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    // }

    approveLoan(formObj,loanBookingRequestId,isManual) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`loan/loan-booking/approval/${loanBookingRequestId}/${isManual}`, bodyObj).pipe(
          map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    verifiyFacility(formObj,loanBookingRequestId) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`loan/loan-booking/verification/${loanBookingRequestId}`, bodyObj).pipe(
          map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    approveLoanFeeOverride(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`loan/loan-booking/fee-override/approval`, bodyObj).pipe(
          map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    approveLoanRequest(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`loan/booking-request/approval`, bodyObj).pipe(
          map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    diburseMultipleLoanRequests(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`loan/bulk-loan-entries`, bodyObj).pipe(
          map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    // benjamin
    uploadBulkCustomerLoanFileForDisbursment(file: File, body: any) {
        return new Promise((resolve, reject) => {

            let url = `loan/pre-multiple-disbursement`;
            let xhr: XMLHttpRequest = new XMLHttpRequest();

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.open('POST', url, true);
            let formData = new FormData();
            formData.append("file", file, file.name);

            for (var key in body) {
                formData.append(key, body[key]);
            }

            let token = this.http.getAuthorizationHeader();
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);

            xhr.send(formData);
        });
    } 

    getSavedBulkLoanDisbursementData() {
        return this.http.get(`loan/ `).pipe(
          map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    setLegalDocumentStatusForLineFacility(loanBookingRequestId,value,formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.put(`loan/loan-request/legal-document-for-lines/${loanBookingRequestId}/${value}`,bodyObj).pipe(
          map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

}
